export enum BrokerRegion {
  A1 = 'A1',
  B1 = 'B1',
}
